.issue-text{width:100%}
/*# sourceMappingURL=flag-technical-issue-modal.component.css.map */
